import { decodeURISearchPart } from 'httongue';
import { rmatchEntry } from '../matchers/rmatch-entry.js';
import { rmatchDirs } from '../matchers/rmatch-dirs.js';
import { rcaptureDirs } from '../matchers/rcapture-dirs.js';
import { rcaptureEntry } from '../matchers/rcapture-entry.js';
/**
 * @internal
 */
export function simpleRouteMatcher(pattern, matcherBySpec = simpleRouteWildcard) {
    switch (pattern) {
        case '*':
            return rmatchEntry;
        case '**':
            return rmatchDirs;
        default:
            if (pattern.startsWith('{') && pattern.indexOf('}') >= pattern.length - 1) {
                const spec = pattern.slice(1, pattern.length - 1);
                return matcherBySpec(spec) || simpleRouteCapture(spec);
            }
            return;
    }
}
/**
 * @internal
 */
export function simpleRouteWildcard(spec) {
    const colonIdx = spec.indexOf(':');
    if (colonIdx >= 0) {
        const capture = decodeURISearchPart(spec.slice(0, colonIdx).trim());
        const arg = spec.slice(colonIdx + 1).trim();
        if (arg === '**') {
            return capture ? rcaptureDirs(decodeURISearchPart(capture)) : rmatchDirs;
        }
        return capture ? rcaptureEntry(capture) : rmatchEntry;
    }
    return;
}
/**
 * @internal
 */
function simpleRouteCapture(spec) {
    spec = spec.trim();
    return spec ? rcaptureEntry(decodeURISearchPart(spec)) : rmatchEntry;
}
//# sourceMappingURL=simple-route-pattern.impl.js.map